module.exports = __webpack_public_path__ + "static/img/25.9db3c6f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gwphoto/25.jpg
// module id = XQOs
// module chunks = 1